import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'shared-components/decorators/spinner';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

const Button = ({
  className = '',
  children = (<FormattedMessage id="hosting.button.button_text" defaultMessage="Save" />),
  onClick = null,
  isLoading = false,
  disabled = false,
  attributes = {},
  type = 'submit',
  childrenWrapperClassName = '',
  category
}) => {
  const buttonClassNames = classnames(`Button btn btn-${category}`, className);

  return (
    <button
      className={buttonClassNames}
      disabled={disabled}
      onClick={onClick}
      type={type}
      { ...attributes }
    >
      {
        isLoading && <Spinner additionalStyle="btn-spinner" />
      }

      <div className={classnames(childrenWrapperClassName, { invisible: isLoading })}>
        {children}
      </div>
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  attributes: PropTypes.object,
  type: PropTypes.oneOf(['submit', 'reset', 'button']),
  category: PropTypes.oneOf(['primary', 'secondary', 'default', 'danger', 'reset']).isRequired
  // reset-plain is a button with just a single icon and no text.
  // reset-plain has no padding, border
};

export default Button;
